import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import withholdingsStore from 'stores/withholdingsStore'
import emailSendModalStore from 'stores/Components/emailSendModalStore'
import LoadingSpinnerAlt from 'Components/LoadingSpinnerAlt'
import { isEmail } from 'react-multi-email'
import { WITHHOLDINGS_DETAIL } from 'Constants/Routes'

const ActionButtons = ({ idWithholding, correlative, providerEmail }) => {
  const { t } = useTranslation()
  const [isDownloading, setIsDownloading] = useState(false)
  const detailPath = WITHHOLDINGS_DETAIL.replace(':id', idWithholding)

  function download() {
    setIsDownloading(true)
    withholdingsStore.downloadDocument(idWithholding, correlative)
      .finally(() => setIsDownloading(false))
  }

  function showEmailModal() {
    emailSendModalStore.openModal(idWithholding, isEmail(providerEmail) ? [providerEmail] : [])
  }

  return (
    <span className="invoice-action-buttons">
      <Link
        to={detailPath}
        className="btn"
        title={t('preview')}
        aria-label={t('preview')}
      >
        <i className="fas fa-eye" />
      </Link>
      <i
        className="fas fa-envelope btn"
        title={t('send_by_email')}
        aria-label={t('send_by_email')}
        onClick={showEmailModal}
      />
      {isDownloading && (
        <div className="d-inline-block action-button-loading-container">
          <LoadingSpinnerAlt />
        </div>
      )}
      {!isDownloading && (
        <i
          className="fas fa-download btn"
          title={t('download')}
          aria-label={t('download')}
          onClick={download}
        />
      )}
    </span>
  )
}

export default ActionButtons
